<template>
  <div class="tab-text w-full">
    <div class="mt-4">
      <div id="user-edit-tab-info">
        <div>
          <div class="vx-row">
            <div class="vx-col w-full mb-base">
              <h2>{{ title }}</h2>
            </div>
          </div>
          <div class="vx-row">
            <div
              class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
              v-for="(section, index) in sections"
              @click="
                select(dataSource[section.key], section.key, section.title)
              "
              :key="index"
            >
              <statistics-card-line
                :icon="section.icon"
                :statistic="getFormattedStatistic(section.key)"
                :statisticTitle="section.title"
                :hideChart="!(section.series && section.series.length)"
                :chartData="section.series"
                :color="section.color"
                type="area"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card :title="tabTitle" class="mb-base">
          <div class="">
            <vs-table max-items="10" search pagination :data="products">
              <template slot="header">
                <p>{{ description }}</p>
              </template>
              <template slot="thead">
                <vs-th sort-key="ref">ID</vs-th>
                <vs-th sort-key="name">Produit</vs-th>
                <vs-th v-if="showPrice && showSale" sort-key="sale_price"
                  >Prix</vs-th
                >
                <vs-th v-if="!showPrice || showclient" sort-key="client_price"
                  >En Main</vs-th
                >
                <vs-th v-if="showPrice && showBenefit" sort-key="benefit"
                  >Benef</vs-th
                >
                <vs-th sort-key="createdAt">Date de dépot</vs-th>
                <vs-th sort-key="status">Statut</vs-th>
                <vs-th sort-key="data">Date changement de statut</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  :id="indextr"
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                  :state="
                    data[indextr].status == 'Vendu'
                      ? 'warning'
                      : data[indextr].status == 'Client payé'
                      ? 'success'
                      : data[indextr].status == 'Retour'
                      ? 'danger'
                      : data[indextr].status == 'Association'
                      ? 'primary'
                      : data[indextr].visibility == false
                      ? 'dark'
                      : null
                  "
                >
                  <vs-td :data="data[indextr].ref">
                    {{ data[indextr].ref }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td
                    v-if="showPrice && showSale"
                    :data="data[indextr].sale_price"
                  >
                    {{ data[indextr].sale_price }}
                  </vs-td>

                  <vs-td
                    v-if="!showPrice || showclient"
                    :data="data[indextr].client_price"
                  >
                    {{ data[indextr].client_price }}
                  </vs-td>

                  <vs-td
                    v-if="showPrice && showBenefit"
                    :data="data[indextr].benefit"
                  >
                    {{ data[indextr].benefit }}
                  </vs-td>

                  <vs-td :data="data[indextr].createdAt">
                    {{ data[indextr].createdAt | datemongoose(true) }}
                  </vs-td>

                  <vs-td :data="data[indextr].status">
                    <p
                      v-if="
                        data[indextr].status === 'Disponible' &&
                        data[indextr].visibility === false
                      "
                    >
                      Annulé
                    </p>
                    <p v-else>
                      {{ data[indextr].status }}
                    </p>
                  </vs-td>

                  <vs-td :data="data[indextr].createdAt">
                    {{
                      data[indextr].date_pickup ||
                      data[indextr].date_returned ||
                      data[indextr].date_paid ||
                      data[indextr].date_sold ||
                      data[indextr].updatedAt | datemongoose(true)
                    }}
                  </vs-td>

                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-full">
                      <div
                        class="con-btns-user flex items-center justify-between"
                      >
                        <div class="con-userx flex items-center justify-start">
                          <vs-table>
                            <template slot="thead">
                              <vs-th>Désignation</vs-th>
                              <vs-th>Date</vs-th>
                            </template>
                            <template slot-scope="{ data }">
                              <vs-tr v-if="tr.createdAt">
                                <vs-td>Date de Dépot</vs-td>
                                <vs-td>
                                  {{ tr.createdAt | datemongoose(true) }} à
                                  {{ tr.createdAt | time(true) }}
                                </vs-td>
                              </vs-tr>
                              <vs-tr v-if="tr.date_sold">
                                <vs-td>Date de Vente</vs-td>
                                <vs-td>
                                  {{ tr.date_sold | datemongoose(true) }} à
                                  {{ tr.date_sold | time(true) }}
                                </vs-td>
                              </vs-tr>
                              <vs-tr v-if="tr.date_paid">
                                <vs-td>Date de Paiement Client</vs-td>
                                <vs-td>
                                  {{ tr.date_paid | datemongoose(true) }} à
                                  {{ tr.date_paid | time(true) }}
                                </vs-td>
                              </vs-tr>
                              <vs-tr v-if="tr.date_returned">
                                <vs-td>Date de Retour</vs-td>
                                <vs-td>
                                  {{ tr.date_returned | datemongoose(true) }} à
                                  {{ tr.date_returned | time(true) }}
                                </vs-td>
                              </vs-tr>
                              <vs-tr v-if="tr.date_pickup">
                                <vs-td>Date de Récupération de l'article</vs-td>
                                <vs-td>
                                  {{ tr.date_pickup | datemongoose(true) }} à
                                  {{ tr.date_pickup | time(true) }}
                                </vs-td>
                              </vs-tr>
                            </template>
                          </vs-table>
                        </div>
                      </div>
                    </div>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    // showTable: {
    //   type: Boolean,
    //   default: false,
    // },
    showPrice: {
      type: Boolean,
      default: false,
    },
    sections: {},
    dataSource: {},
  },
  data() {
    return {
      tabTitle: "Articles",
      chartOptions: null,
      products: [],
      description: "",
      showSale: true,
      showclient: true,
      showBenefit: true,
    };
  },
  methods: {
    getFormattedStatistic(key) {
      // Format returnedCount to show total (pending) with smaller, non-bold text for pending
      if (key === 'returnedCount' && this.dataSource) {
        const total = this.dataSource.returnedCount || 0;
        const pending = this.dataSource.returnedCountClient || 0;
        return `${total} <span style="font-size: 0.7em; font-weight: normal;">(${pending} à récupérer)</span>`;
      }
      // Return normal statistic for other keys
      return this.dataSource[key];
    },
    select(data, key, title) {
      switch (key) {
        case "productCount": {
          this.tabTitle = title;
          this.showSale = true;
          this.showclient = true;
          this.showBenefit = true;
          this.products = this.dataSource.products;
          this.description = "Liste de tous les articles déposés";
          break;
        }
        case "availableCount": {
          this.tabTitle = title;
          this.showSale = true;
          this.showclient = true;
          this.showBenefit = true;
          this.products = this.dataSource.available;
          this.description =
            "Liste de tous les articles actuellement disponibles et mis en vente";
          break;
        }
        case "soldCount": {
          this.tabTitle = title;
          this.showSale = true;
          this.showclient = true;
          this.showBenefit = true;
          this.products = this.dataSource.sold;
          this.description =
            "Liste de tous les articles vendus (vendus et payés)";
          break;
        }
        case "returnedCount": {
          this.tabTitle = title;
          this.showSale = true;
          this.showclient = true;
          this.showBenefit = true;
          this.products = [
            ...this.dataSource.returned,
            ...(this.dataSource.pickup || []),
          ];
          this.description =
            "Liste de tous les articles retournés (retours et pickups)";
          break;
        }
        case "associationCount": {
          this.tabTitle = title;
          this.showSale = true;
          this.showclient = true;
          this.showBenefit = true;
          this.products = this.dataSource.association || [];
          this.description =
            "Liste de tous les articles donnés à l'association";
          break;
        }
        case "returnedCountClient": {
          this.tabTitle = title;
          this.products = this.dataSource.returned;
          this.description =
            "Liste de tous les articles retournés (retours et pickups)";
          break;
        }
        case "notPaidCount": {
          this.tabTitle = title;
          this.products = this.dataSource.notPaid;
          this.description =
            "Liste de tous les articles vendus dont le déposant n'a toujours pas reçu son paiement";
          break;
        }
        case "paidCount": {
          this.tabTitle = title;
          this.products = this.dataSource.paid;
          this.description =
            "Liste de tous les articles payés (le déposant a reçu son paiement)";
          break;
        }
        case "revenues": {
          this.tabTitle = title;
          this.showSale = true;
          this.showclient = false;
          this.showBenefit = false;
          this.products = this.dataSource.sold;
          this.description =
            "Liste de tous les articles vendus (vendus et payés)";
          break;
        }
        case "benefit": {
          this.tabTitle = title;
          this.showSale = false;
          this.showclient = false;
          this.showBenefit = true;
          this.products = this.dataSource.sold;
          this.description =
            "Liste de tous les articles vendus (vendus et payés). Le benefice est la somme des benefices des produits vendus et payés";
          break;
        }
        case "payments": {
          this.tabTitle = title;
          this.showSale = false;
          this.showclient = true;
          this.showBenefit = false;
          this.products = this.dataSource.paid;
          this.description =
            "Liste des produits dont le décaissement client a été effectué";
          break;
        }
        case "futurePayments": {
          this.tabTitle = title;
          this.showSale = false;
          this.showclient = true;
          this.showBenefit = false;
          this.products = this.dataSource.notPaid;
          this.description =
            "Liste des produits vendus dont le décaissement client n'a pas encore été effectué";
          break;
        }
        case "comission": {
          this.tabTitle = title;
          this.showSale = true;
          this.showclient = true;
          this.showBenefit = false;
          this.products = this.dataSource.sold;
          this.description =
            "La caisse est la somme des prix de vente des articles vendus (orange) MOINS les paiements clients effectués (vert). En d'autre termes: Recette ventes - Décaissements déposants";
          break;
        }
        case "credit": {
          this.tabTitle = title;
          this.products = this.dataSource.notPaid;
          this.description =
            "Liste de tous les articles vendus dont le déposant n'a toujours pas reçu son paiement";
          break;
        }
        case "clientCount": {
          this.tabTitle = title;
          this.products = [];
          this.description =
            "La liste est non-clickable, prière de visitee l'interface client";
          break;
        }
        default: {
          this.tabTitle = "Articles";
          this.products = [];
        }
      }
    },
  },
  components: {
    StatisticsCardLine,
  },
};
</script>
